
import category from './category'
import poi from './poi'

export default {
  name: 'PoiCategory',
  path: 'poi',
  meta: {
    label: 'poi',
    auth: 'poi'
  },
  component: {
    name: 'Poi',
    render(c) {
      return c('router-view')
    }
  },
  children: [category, poi]
}
